import { FormBuilderSchema } from "../../../modules/FormBuilderCore/Types"

export type ConfigurableAuthenticationProvider = {
	authenticationProviderId: string
	displayName: string
	producesAnonymousLogin: boolean
	state: BaseAuthenticationProviderState | undefined
	formBuilderSchema: FormBuilderSchema
}

export type BaseAuthenticationProviderState = {
	description: string | undefined
}

export type AuthenticationProviderInstance = {
	id: number
	authenticationProviderId: string
	displayName: string
	state: BaseAuthenticationProviderState | undefined
}

export type AuthenticationProviderMetadata = InternalAuthenticationProviderMetadata | AuthenticationProviderInstanceMetadata

type BaseAuthenticationProviderMetadata = {
	displayName: string
	description: string
	providerType: string
	producesAnonymousLogin: boolean
	isMissingPlugin: boolean
}

export type InternalAuthenticationProviderMetadata = BaseAuthenticationProviderMetadata & {
	isInternal: true
	id: string
}

export type AuthenticationProviderInstanceMetadata = BaseAuthenticationProviderMetadata & {
	isInternal: false
	id: number
}

export type BaseAuthenticationProviderInstanceModel = {
	displayName: string
	authenticationProviderId: string
	state: Record<string, unknown>
}

export type OidcAuthenticationProviderLoginModel = {
	oidcRequestData: string
	redirectUrl: string
}

export type AuthenticationProviderSettings = {
	isFimAuthDisabled: boolean
	defaultProviderId: string // the instance id OR "FormsInMotion Authentication"
}

export type InternalAuthenticationProvider = {
	id: string
	displayName: string
	description: string
	producesAnonymousLogin: boolean
}

export const InternalAuthenticationProviders = {
	["FimUsernamePasswordId"]: "FC453EBA-B379-4170-B468-CBC801C4C3C5",
	["FimAnonymousId"]: "26449BA4-26C2-4BEF-A04C-2197271D2979"
}